import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export function MobileCTA() {
  return (
    <div className="fixed inset-x-4 bottom-4 z-40 md:hidden" data-testid="mobile-cta">
      <Link to="/eligibility" className="flex items-center justify-between rounded-full bg-primary py-3.5 pl-6 pr-4 text-sm font-semibold text-primary-foreground shadow-card">
        Check eligibility, free <ArrowRight className="h-4 w-4" />
      </Link>
    </div>
  );
}
